export interface UiNotificationService {
  show(params: { text: string; type: 'success' | 'error' }): void;
}

export function $notification($mdToast: angular.material.IToastService) {
  return {
    show({ text, type: _ }: { text: string; type: 'success' | 'error' }) {
      $mdToast.show(
        $mdToast
          .simple()
          .textContent(text)
          .position('bottom left')
          .hideDelay(7000),
      );
    },
  };
}

$notification.$inject = ['$mdToast'];
